import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import BrandLogoImage from "../common/BrandLogoImage";
import TireListingView from "../list/TireListingView";

const styles = (theme) => ({
  header: {
    marginBottom: theme.spacing(3),
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(0.5),
  },
  brandLogo: {
    display: "block",
    height: 40,
    width: "auto",
  },
  title: {
    marginTop: 0,
  },
  sizeRow: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: theme.spacing(1),
    marginTop: theme.spacing(1.5),
  },
  emptyState: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(4),
    textAlign: "center",
  },
  emptyText: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
});

class TireResultsByBrandPage extends React.Component {
  componentDidMount() {
    this.ensureBrandLoaded();
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.brand !== this.props.match.params.brand) {
      this.ensureBrandLoaded();
      window.scrollTo(0, 0);
    }
  }

  ensureBrandLoaded() {
    const { brand } = this.props.match.params;
    if (this.props.catalog.motoTiresQueryKey !== `brand:${brand}`) {
      this.props.actions.setListPending(true);
      this.props.actions.searchTiresByBrand(brand);
    }
  }

  renderHeader() {
    const { classes } = this.props;
    const { brand } = this.props.match.params;

    return (
      <header className={classes.header}>
        <Typography variant="overline" color="textSecondary">
          צמיגים לאופנוע · לפי מותג
        </Typography>
        <div className={classes.titleRow}>
          <BrandLogoImage
            brand={brand}
            alt={brand}
            className={classes.brandLogo}
            fallback={null}
          />
          <Typography variant="h4" component="h1" className={classes.title}>
            {"צמיגי "}
            <bdi>{brand}</bdi>
            {" לאופנוע"}
          </Typography>
        </div>
        <div className={classes.sizeRow}>
          <Button component={Link} to="/" color="primary" size="small">
            חיפוש לפי מידה
          </Button>
        </div>
      </header>
    );
  }

  renderEmpty() {
    const { classes } = this.props;

    return (
      <div className={classes.emptyState}>
        <Typography variant="h6" component="h2">
          לא נמצאו צמיגים למותג זה
        </Typography>
        <div className={classes.emptyText}>
          <Button component={Link} to="/" variant="outlined" color="primary">
            חזרה לחיפוש
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const { catalog, actions } = this.props;
    const { brand } = this.props.match.params;
    const metaTitle = `צמיגים לאופנועים מתוצרת ${brand} - ספורטישופ`;
    const metaDesc = `מגוון רחב של צמיגים מתוצרת ${brand} בהנחות גבוהות עד 65% הנחה!`;
    const queryKey = `brand:${brand}`;

    return (
      <React.Fragment>
        <Helmet>
          <meta property="og:title" content={metaTitle} />
          <meta property="og:description" content={metaDesc} />
          <meta property="description" content={metaDesc} />
          <title>{metaTitle}</title>
        </Helmet>
        <TireListingView
          header={this.renderHeader()}
          products={catalog.motoTires}
          pending={catalog.listPending || catalog.motoTiresQueryKey !== queryKey}
          emptyState={this.renderEmpty()}
          availabilityContext={{
            currentShipment: catalog.currentShipment,
            nextShipment: catalog.nextShipment,
            euContainerMode: catalog.euContainerMode,
          }}
          limitedTimeOffers={catalog.limitedTimeOffers || []}
          addProductsToCart={actions.addProductsToCart}
          collectMetric={actions.collectMetric}
          metricSource="list_page_by_brand"
          resetKey={queryKey}
        />
      </React.Fragment>
    );
  }
}

TireResultsByBrandPage.propTypes = {
  classes: PropTypes.object.isRequired,
  actions: PropTypes.object,
  catalog: PropTypes.object.isRequired,
  match: PropTypes.object,
};

export default withStyles(styles)(TireResultsByBrandPage);
